
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Vishrantwaditomumbaicab() {



    const cardData =
    {
        keyword: 'Vishrantwadi to Mumbai Cab',
        heading: 'Meghana Cab : Vishrantwadi to Mumbai Cab',
        headingDescription: 'Meghana Cab offers Vishrantwadi to Mumbai Cab service, delivering a reliable and comfortable travel experience from Pune’s well-connected residential area to the vibrant city of Mumbai. Whether you need a cab for an airport transfer, business trip, or family outing, we offer a wide range of vehicles including Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers to suit your needs. With door-to-door pickups from Vishrantwadi, experienced drivers, on-time service, transparent fares, and 24/7 customer support, Meghana Cab ensures a smooth and stress-free journey. Book your Vishrantwadi to Mumbai Cab today for safe and convenient intercity travel.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
   {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

    "services": [
    {
      "name": "Vishrantwadi to Mumbai Taxi Booking",
      "description": "Book your taxi from Vishrantwadi to Mumbai effortlessly through our online platform, ensuring a smooth and hassle-free experience with instant confirmation and flexible payment options."
    },
    {
      "name": "One Way Cab Vishrantwadi to Mumbai",
      "description": "Choose our convenient one-way cab service for a direct and efficient journey from Vishrantwadi to Mumbai, perfect for single trips without any return commitments."
    },
    {
      "name": "Round Trip Cab Vishrantwadi to Mumbai",
      "description": "Plan your round trips comfortably with our reliable taxi services between Vishrantwadi and Mumbai, offering flexibility and guaranteed availability for both onward and return rides."
    },
    {
      "name": "Budget Cab Vishrantwadi to Mumbai",
      "description": "Travel economically without compromising on comfort with our budget-friendly cab options from Vishrantwadi to Mumbai, suitable for all types of travelers."
    },
    {
      "name": "AC Sedan Hire Vishrantwadi to Mumbai",
      "description": "Experience comfortable and cool rides with our air-conditioned sedan taxis, perfect for business or leisure trips from Vishrantwadi to Mumbai."
    },
    {
      "name": "SUV Taxi Vishrantwadi to Mumbai",
      "description": "Hire spacious SUV taxis for group travel or when you need extra luggage space, ensuring a comfortable journey from Vishrantwadi to Mumbai."
    },
    {
      "name": "Online Cab Booking Vishrantwadi to Mumbai",
      "description": "Easily book your taxi online anytime with secure payment gateways and real-time availability, making your Vishrantwadi to Mumbai travel planning hassle-free."
    },
    {
      "name": "Family Cab Vishrantwadi to Mumbai",
      "description": "Travel safely with your family using our dedicated family cab services, designed for comfort and convenience on the route from Vishrantwadi to Mumbai."
    },
    {
      "name": "Chauffeur Driven Cab Vishrantwadi to Mumbai",
      "description": "Enjoy a stress-free journey with our professional chauffeur-driven cabs, where experienced drivers ensure timely and safe travel from Vishrantwadi to Mumbai."
    },
    {
      "name": "Reliable Travel Cab Vishrantwadi to Mumbai",
      "description": "Depend on our reliable cab services with punctual pickups, well-maintained vehicles, and courteous drivers for a seamless trip between Vishrantwadi and Mumbai."
    },
    {
      "name": "Corporate Taxi Vishrantwadi to Mumbai",
      "description": "Specialized corporate taxi services for business travelers, offering professionalism, privacy, and comfort from Vishrantwadi to Mumbai."
    },
    {
      "name": "Fast Booking Cab Vishrantwadi to Mumbai",
      "description": "Make instant cab bookings with our fast and user-friendly system, ensuring quick confirmations for your Vishrantwadi to Mumbai trips."
    },
    {
      "name": "Private Taxi Vishrantwadi to Mumbai",
      "description": "Avail exclusive private taxi rides that provide a direct route and personalized service for your travel needs between Vishrantwadi and Mumbai."
    },
    {
      "name": "Long Route Cab Vishrantwadi to Mumbai",
      "description": "Our long-route taxi services are ideal for travelers seeking comfort and reliability on the longer journey from Vishrantwadi to Mumbai."
    },
    {
      "name": "24/7 Cab Service Vishrantwadi to Mumbai",
      "description": "Benefit from our round-the-clock cab services, available anytime to accommodate your schedule for travel between Vishrantwadi and Mumbai."
    }
  ],
  "tableData": [
    ["Vishrantwadi to Mumbai Taxi Booking", "One Way Cab Vishrantwadi to Mumbai"],
    ["Round Trip Cab Vishrantwadi to Mumbai", "Budget Cab Vishrantwadi to Mumbai"],
    ["AC Sedan Hire Vishrantwadi to Mumbai", "SUV Taxi Vishrantwadi to Mumbai"],
    ["Online Cab Booking Vishrantwadi to Mumbai", "Family Cab Vishrantwadi to Mumbai"],
    ["Chauffeur Driven Cab Vishrantwadi to Mumbai", "Reliable Travel Cab Vishrantwadi to Mumbai"],
    ["Corporate Taxi Vishrantwadi to Mumbai", "Fast Booking Cab Vishrantwadi to Mumbai"],
    ["Private Taxi Vishrantwadi to Mumbai", "Long Route Cab Vishrantwadi to Mumbai"],
    ["24/7 Cab Service Vishrantwadi to Mumbai", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Dependable Vishrantwadi to Mumbai Cab Service",
        "WhyChoosedescription": "Our cab service from Vishrantwadi to Mumbai ensures reliable, on-time transportation for all types of travelers. Whether you're heading to the airport, a business meeting, or a family event, we make your journey smooth and worry-free from door to door."
    },
    {
        "WhyChooseheading": "Clean, Comfortable, and Well-Equipped Cabs",
        "WhyChoosedescription": "Travel in fully air-conditioned, sanitized, and well-maintained vehicles. Our fleet includes sedans, SUVs, and luxury options to suit your group size and comfort needs, ensuring a pleasant journey even during long hours on the road."
    },
    {
        "WhyChooseheading": "Trained and Professional Drivers",
        "WhyChoosedescription": "Our drivers are background-verified, courteous, and experienced with the Vishrantwadi to Mumbai route. They prioritize your safety and time, choosing the most efficient roads while providing friendly, respectful service throughout the ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy honest, upfront pricing with no hidden charges. Our rates include fuel, tolls, taxes, and driver fees, offering you a budget-friendly solution with premium service quality. You pay only what you see—no surprises later."
    },
    {
        "WhyChooseheading": "Flexible Travel Plans and Easy Scheduling",
        "WhyChoosedescription": "Book a one-way trip, return journey, or even a full-day rental with ease. We offer flexible booking options, letting you set your pickup time and destination according to your unique travel schedule and preferences."
    },
    {
        "WhyChooseheading": "Convenient Doorstep Pickup and Drop-off",
        "WhyChoosedescription": "Skip the hassle of transit or crowded pickup points. Our service includes direct pickup from your home or office in Vishrantwadi and drop-off at any location in Mumbai, including hotels, offices, or airports."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Work Trips, and Family Travel",
        "WhyChoosedescription": "Whether you're traveling solo or with family, for business or vacation, our cabs provide ample space, reliable timing, and a stress-free experience. Our service is ideal for Mumbai airport transfers, office commutes, or long-distance leisure trips."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Instant Booking Assistance",
        "WhyChoosedescription": "Have a question or need to book at odd hours? Our customer support is available 24/7 to assist you with bookings, changes, or last-minute travel needs. We ensure help is always just a call or click away."
    }
]














    }

const faqData = [
    {
        question: "How do I book a cab from Vishrantwadi to Mumbai?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for easy online reservations."
    },
    {
        question: "What is the usual travel time from Vishrantwadi to Mumbai by cab?",
        answer: "The journey generally takes around 3 to 4 hours depending on traffic conditions."
    },
    {
        question: "Are one way and round trip cab options available from Vishrantwadi to Mumbai?",
        answer: "Yes, both one way and round trip services are offered to suit your travel needs."
    },
    {
        question: "What types of vehicles can I choose for the Vishrantwadi to Mumbai route?",
        answer: "We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers."
    },
    {
        question: "Is the Vishrantwadi to Mumbai cab service available 24/7?",
        answer: "Yes, our services operate 24/7 to accommodate your schedule."
    },
    {
        question: "What is included in the fare for Vishrantwadi to Mumbai cabs?",
        answer: "The fare covers fuel, tolls, and driver charges. Extra parking or waiting fees may apply."
    },
    {
        question: "Can I book a last-minute cab from Vishrantwadi to Mumbai?",
        answer: "Yes, last-minute bookings are accepted subject to vehicle availability. Contact us for quick booking."
    },
    {
        question: "Is online booking and payment available for this service?",
        answer: "Yes, online booking and multiple payment options including UPI, cards, and net banking are available."
    },
    {
        question: "Can I request stops for food or rest during the trip?",
        answer: "Yes, you can request stops during the journey. Please inform us when booking or notify the driver."
    },
    {
        question: "Are the drivers experienced with the Vishrantwadi to Mumbai route?",
        answer: "Absolutely. Our drivers are professional, trained, and familiar with the best routes."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The cab service from Vishrantwadi to Mumbai was punctual and comfortable. Highly recommended!”',
    },
    {
        name: 'Ms. Priya Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Smooth booking and friendly driver. Great experience with Meghana Cab.”',
    },
];



































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vishrantwadi to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/vishrantwadi-to-mumbai-cab.jpg",
  "description": "Book affordable and reliable cab service from Vishrantwadi to Mumbai with Meghana Cabs. Available 24/7 with AC, SUV, sedan, and chauffeur-driven taxis for one-way and round trips. Easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1650",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/vishrantwadi-to-mumbai-cab-service"
  }
};





    return (
        <div>

<Helmet>
  <title>Vishrantwadi to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book affordable and reliable cab service from Vishrantwadi to Mumbai with Meghana Cabs. Available 24/7 with AC, SUV, sedan, and chauffeur-driven taxis for one-way and round trips. Easy online booking." 
  />
  <meta 
    name="keywords" 
    content="Vishrantwadi to Mumbai Taxi Booking, One Way Cab Vishrantwadi to Mumbai, Round Trip Cab Vishrantwadi to Mumbai, Budget Cab Vishrantwadi to Mumbai, AC Sedan Hire Vishrantwadi to Mumbai, SUV Taxi Vishrantwadi to Mumbai, Online Cab Booking Vishrantwadi to Mumbai, Family Cab Vishrantwadi to Mumbai, Chauffeur Driven Cab Vishrantwadi to Mumbai, Reliable Travel Cab Vishrantwadi to Mumbai, Corporate Taxi Vishrantwadi to Mumbai, Fast Booking Cab Vishrantwadi to Mumbai, Private Taxi Vishrantwadi to Mumbai, Long Route Cab Vishrantwadi to Mumbai, 24/7 Cab Service Vishrantwadi to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Vishrantwaditomumbaicab;